// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".animation-preview[data-v-9de4e2f8] {\n  max-width: 500px;\n}\n", ""]);
// Exports
module.exports = exports;
